import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"

export default function NoResults() {
    const query = useAppStateSelector(state => state.response.query)

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            <h1 class="h1">No results for '{query}'</h1>
            <div class="nosto-rec-container">
                <div class="nosto_element" id="noresults-nosto-1"></div>
            </div>
        </div>
    )
}
